import React from "react";
import "./Stepper.css";

const defaultLabels = ["Shopping cart", "Checkout details", "Order complete"];

const Stepper = ({ current = 1, labels = defaultLabels }) => {
  const steps = [1, 2, 3];

  return (
    <div className="cart-stepper" role="list" aria-label="Checkout progress">
      {steps.map((n, idx) => {
        const isDone = n < current;
        const isCurrent = n === current;
        const isLast = idx === steps.length - 1;

        return (
          <div
            key={n}
            role="listitem"
            className={[
              "cart-step",
              isDone ? "cart-step--completed" : "",
              isCurrent ? "cart-step--active" : "",
              isLast ? "cart-step--last" : "",
            ]
              .join(" ")
              .trim()}
          >
            <div className="cart-step__label">
              {isDone ? (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <span>{n}</span>
              )}
            </div>
            <div className="cart-step__text">{labels[idx]}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
